interface IProps {
  className?: string;
}

export const MarketScanIconV2 = ({ className }: IProps) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9995 11.9995C11.9995 13.6564 10.6564 14.9995 8.99951 14.9995C7.34266 14.9995 5.99951 13.6564 5.99951 11.9995C5.99951 10.3427 7.34266 8.99951 8.99951 8.99951C10.6564 8.99951 11.9995 10.3427 11.9995 11.9995Z"
        fill="#14181F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.09961 4.09961H6.99961V5.89961H3.89961V8.99961H2.09961V4.09961ZM20.0996 5.89961H16.9996V4.09961H21.8996V8.99961H20.0996V5.89961ZM3.89961 18.0996V14.9996H2.09961V19.8996H6.99961V18.0996H3.89961ZM20.0996 18.0996V14.9996H21.8996V19.8996H16.9996V18.0996H20.0996Z"
        fill="#14181F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.4995 12.9995C16.0518 12.9995 16.4995 12.5518 16.4995 11.9995C16.4995 11.4472 16.0518 10.9995 15.4995 10.9995C14.9472 10.9995 14.4995 11.4472 14.4995 11.9995C14.4995 12.5518 14.9472 12.9995 15.4995 12.9995ZM15.4995 14.4995C16.8802 14.4995 17.9995 13.3802 17.9995 11.9995C17.9995 10.6188 16.8802 9.49951 15.4995 9.49951C14.1188 9.49951 12.9995 10.6188 12.9995 11.9995C12.9995 13.3802 14.1188 14.4995 15.4995 14.4995Z"
        fill="#14181F"
      />
    </svg>
  );
};
